import { GENDER_LIST_ONBOARDING } from 'src/consumer/constants'
import { getPrescriptionDisplayAge } from 'src/consumer/helpers/profilePageHelper'
import { getDateOfPrescription } from '../../../PrescriptionMakingPageComponents'
import { PMPHeaderDetails } from '../../../PrescriptionMakingPageStyles'
import PrescriptionKVItem from '../../common/PrescriptionKVItem'

export default function ThreeColumnPrescriptionFooterPatientDetails({
  prescriptionData,
  leaveSpace,
  debug,
  prescriptionViewSettings,
  customConfigs,
  customizations = {},
}) {
  return (
    <>
      <PMPHeaderDetails
        debug={debug}
        noColor={true}
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          borderTop: '1px solid black',
          padding: '5px 8px',
        }}
      >
        <PrescriptionKVItem
          itemKey="Patient"
          topContainerProps={{ style: customizations.patientNameKeyStyle }}
          valueItemProps={{ style: customizations.patientNameValStyle }}
          value={
            <>
              <span style={customizations.patientNameValStyle}>
                {prescriptionData?.patientPrefill?.patientNumber
                  ? `(${prescriptionData?.patientPrefill?.patientNumber})`
                  : ''}{' '}
                {prescriptionData?.patientPrefill?.name}
              </span>
              {customizations.showAgeGender !== false && (
                <span style={customizations.patientAgeGenderValStyle}>
                  , {getPrescriptionDisplayAge(prescriptionData)}/
                  {
                    GENDER_LIST_ONBOARDING?.find(
                      (item) => item.value === prescriptionData?.patientPrefill?.vital?.gender,
                    )?.label
                  }
                </span>
              )}
              {customizations.showMobile && prescriptionData?.patientPrefill?.mobile && (
                <span style={customizations.patientMobileValStyle}>
                  , {prescriptionData?.patientPrefill?.mobile}
                </span>
              )}
              {customizations.showAddress && prescriptionData?.patientPrefill?.location?.city && (
                <span style={customizations.patientAddressValStyle}>
                  , {prescriptionData?.patientPrefill?.location?.city}
                </span>
              )}
              {customizations.showEmail && prescriptionData?.patientPrefill?.email && (
                <span style={customizations.patientEmailValStyle}>
                  , {prescriptionData?.patientPrefill?.email}
                </span>
              )}
            </>
          }
        />
        <PrescriptionKVItem
          containerType="div"
          itemKey="Date"
          topContainerProps={{ className: 'd-flex align-items-center justify-content-end gap-1' }}
          value={getDateOfPrescription(prescriptionData, false)}
        />
      </PMPHeaderDetails>
    </>
  )
}
